import PanelTemplate from "components/shared/profile/panel";
import { syncSystemBehaviors, syncSystemTrackingTypes } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React from "react";
import { config, initialState } from "./syncSystemForm/config";

class SyncSystemsSettings extends PanelTemplate {
    renderBody = () => {
        const { syncSystems } = this.props.data;
        return (
            <div>
                <div className="overflow-auto">
                    <table className="table table-striped m-0 table-sm">
                        <thead>
                            <tr>
                                <th scope="col">Пользователь</th>
                                <th scope="col">Ключ ВИС</th>
                                <th scope="col">Поведение</th>
                                <th scope="col">Тип изменения для отслеживания</th>
                                <th scope="col" />
                            </tr>
                        </thead>
                        <tbody>
                            {syncSystems && syncSystems.length > 0 ? (
                                syncSystems.map((el, key) => (
                                    <tr key={key}>
                                        <td>{el.userDisplayName}</td>
                                        <td className="mw-200">{el.key}</td>
                                        <td>{enumLabel(syncSystemBehaviors, el.behavior)}</td>
                                        <td>{enumLabel(syncSystemTrackingTypes, el.trackingType)}</td>
                                        <td className="d-flex justify-content-end">
                                            <button
                                                onClick={() => this.updateSystemSync(el)}
                                                type="button"
                                                className="btn btn-warning btn-xs mr-2"
                                            >
                                                <i className="icon-uEA10-pen"></i>
                                            </button>
                                            <button
                                                onClick={() => this.removeSystemSync(el.id)}
                                                type="button"
                                                className="btn btn-danger btn-xs"
                                            >
                                                <i className="icon-uEA31-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td className="text-center" colSpan={5}>
                                        Список пуст
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="inline-btn inline-btn--plus mt-2" onClick={this.addSystemSync}>
                    Добавить
                </div>
            </div>
        );
    };

    update = (stateData) => {
        if (this.isValidForm(stateData)) {
            return this.props
                .action(stateData)
                .then((res) => (res ? this.props.update() : this.setState({ isValid: false })));
        }
    };

    addSystemSync = () => {
        this.props.modal({
            name: "syncSystem",
            windowMod: "wide",
            title: "Создание настройки интеграции с ВИС",
            update: this.update,
        });
    };

    updateSystemSync = (item) => {
        this.props.modal({
            name: "syncSystem",
            windowMod: "wide",
            title: "Редактирование настройки интегации с ВИС",
            data: item,
            update: this.update,
        });
    };

    removeSystemSync = (id) => {
        this.props.modal({
            name: "confirm",
            title: "Удаление настройки интеграции с ВИС",
            text: "Вы уверены, что хотите удалить настройку интеграции с ВИС?",
            buttons: { confirm: "Да", cancel: "Нет" },
            action: () => this.props.delete({ id }),
            onSuccessAction: () => this.props.update(),
        });
    };

    render() {
        return (
            <div className="card card-body mb-3">
                <h5 className="mb-4">Настройка интеграции с ВИС</h5>
                {this.renderBody()}
            </div>
        );
    }
}

const ConfiguredPanel = (props) => <SyncSystemsSettings {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
